import { IGigPayoutsUpload } from "store/partner-services/partnerServicesSlice";

const STORAGE_KEY = "processingAlterEarnings";

export const persistProcessingAlterEarnings = (data: IGigPayoutsUpload) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
};

export const getPersistedProcessingAlterEarnings = (): IGigPayoutsUpload => {
  const stored = localStorage.getItem(STORAGE_KEY);
  return stored ? JSON.parse(stored) : {};
};

export const removePersistedProcessingAlterEarnings = () => {
  localStorage.removeItem(STORAGE_KEY);
};
